var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"watermark-host",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"watermark-token-host"}),_vm._l((_vm.positions),function(position){return _c('span',{key:position,class:['watermark-text', `watermark-text--${position}`]},[_vm._v(" "+_vm._s(_vm.watermarkText)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }